module.exports = __webpack_public_path__ + "img/bg_1.84578719.jpg";